/**
 * Hong Kong country aliases used for matching country of installation
 */
export const HONG_KONG_ALIASES = ['hk', 'hongkong', 'hong kong']

/**
 * Determines if the country of installation is Hong Kong
 * @param {string} countryString - The country of installation string
 * @returns {boolean} True if country is Hong Kong, false otherwise
 */
export const isCountryOfInstallHongKong = (countryString) => {
  if (!countryString) {
    return false
  }

  const normalizedCountry = (countryString || '').trim().toLowerCase()

  return HONG_KONG_ALIASES.includes(normalizedCountry)
}
